import { render } from "./HeroiconsSolidXCircle.vue?vue&type=template&id=9ef9c662"
const script = {}

import exportComponent from "/Users/valdisaglonietis/PhpstormProjects/news_site/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidXCircle.vue"]])

export default __exports__